// extracted by mini-css-extract-plugin
module.exports = {"searchWrp":"simpleSearch_searchWrp__b3n3G","searchText":"simpleSearch_searchText__1yfZ8","searchWithMargin":"simpleSearch_searchWithMargin__17YAB"};